import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/ContactForm/ContactForm.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/iyde-build/public_html/components/SupportBar/SupportBar.jsx");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/cl.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/ml.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/ph.svg");
;
import(/* webpackMode: "eager" */ "/root/iyde-build/public_html/public/icon/wh.svg");
